import React, { useState } from 'react';

import Tabs from '@components/uikit/Tabs/Tabs';

import useTranslation from '@hooks/useTranslation';

import type { IInstallationPoint } from '@model/installationPoint';

import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

import HistoryTableByAi from '../HistoryTableSensorAi/HistoryTableSensorAi';
import HistoryTableSensorLogsData from '../HistoryTableSensorLogs/HistoryTableSensorLogs';
import style from './style.module.scss';

interface IProps {
  point?: IInstallationPoint;
  isPointLoading?: boolean;
}

const SensorHistory: React.FC<IProps> = ({ point, isPointLoading = false }) => {
  const { t } = useTranslation();

  const [historyView, setHistoryView] = useState('ai');

  const { data: profileData } = useUserProfileQuery();
  const dateFormat = profileData?.dateFormat.date || '';

  return (
    <div className={style.historyBlock}>
      <div className={style.blockTitle}>{t('History')}</div>
      <div className={style.blockContainer}>
        <div className={style.filter}>
          <Tabs
            label={t('View')}
            id="history-view"
            value={historyView}
            tabsItems={[
              { value: 'ai', label: t('Action Item') },
              { value: 'sensor', label: t('Sensor Replacement') },
            ]}
            type="woHelperText"
            onChange={setHistoryView}
            variant="horizontal"
          />
        </div>
        {historyView === 'ai' ? (
          <HistoryTableByAi dateFormat={dateFormat} point={point} isPointLoading={isPointLoading} />
        ) : (
          <HistoryTableSensorLogsData dateFormat={dateFormat} isPointLoading={isPointLoading} />
        )}
      </div>
    </div>
  );
};

export default SensorHistory;
